var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['header-container',{'open-overlay':_vm.overlayOpen}]},[_c('div',{staticClass:"container-1"},[_c('div',{staticClass:"header-div"},[_c('header-content')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }